import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_UPDATE_FILTERS } from './url-constants';

type ManageAlarmsFilterUpdateEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsFilterUpdateEndpointSpecification: ManageAlarmsFilterUpdateEndpointSpecification = {
    url: MANAGE_ALARM_UPDATE_FILTERS,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'ManageAlarmsFilterUpdateRequestParams',
    requestBodySchemaName: 'ManageAlarmsFilterUpdateRequestBody',
    okResponseSchemaName: 'ManageAlarmsFilterUpdateOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmFilterUpdate = Helpers.makeApiRequestFn<
    Types.ManageAlarmsFilterUpdateRequestParams,
    Types.ManageAlarmsFilterUpdateRequestBody,
    Types.ManageAlarmsFilterUpdateOkResponse
>(ManageAlarmsFilterUpdateEndpointSpecification);
